import { render } from "./SysDefine.vue?vue&type=template&id=3c48e576&scoped=true"
import script from "./SysDefine.vue?vue&type=script&lang=js"
export * from "./SysDefine.vue?vue&type=script&lang=js"

import "./SysDefine.vue?vue&type=style&index=0&id=3c48e576&lang=less&scoped=true"

import exportComponent from "E:\\work\\苏州卓盛\\捷博独立发货\\jb-dji-wms-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c48e576"]])

export default __exports__